import React from 'react';
import { TagsIcon } from 'react-line-awesome';
function Index({
  color = 'blue'
}) {
  return <div className={`tag-circle tag-circle-${color}`}>
      <TagsIcon />
    </div>;
}
export default Index;